import type { CatalogProductRow } from './catalogTypes';

export type CompletenessIssue = {
  field: string;
  label: string;
};

export function getProductCompletenessIssues(product: CatalogProductRow): CompletenessIssue[] {
  const issues: CompletenessIssue[] = [];

  if (product.isMisc) return issues;

  const barcode = product.barcode != null ? String(product.barcode).trim() : '';
  const sku = product.sku != null ? String(product.sku).trim() : '';
  if (!barcode && !sku) {
    issues.push({ field: 'code', label: 'Sin código' });
  }

  if (!product.categoryId) {
    issues.push({ field: 'category', label: 'Sin categoría' });
  }

  if (product.itemType !== 'service') {
    if (product.isCombo) {
      if (product.comboReferenceComplete === false) {
        issues.push({ field: 'cost', label: 'Costo ref. incompleto' });
      }
    } else {
      const avgCost = product.stockAvgCost ?? null;
      if (avgCost == null || avgCost <= 0) {
        issues.push({ field: 'cost', label: 'Sin costo' });
      }
    }
  }

  return issues;
}

export function getProductCompletenessSummary(product: CatalogProductRow): string {
  const issues = getProductCompletenessIssues(product);
  if (issues.length === 0) return '';
  return issues.map((i) => i.label).join(' · ');
}
